const ADD_REMOVE_FOLDER_OPTION = 'ADD_REMOVE_FOLDER_OPTION';
const UPDATE_CATEGORY_SELECTED = 'UPDATE_CATEGORY_SELECTED';
const SAVE_FOLDERS_PATH  = 'SAVE_FOLDERS_PATH';
const ADD_REMOVE_FILE_OPTION = 'ADD_REMOVE_FILE_OPTION';
const SAVE_FILE_NAME = 'SAVE_FILE_NAME';
const GET_FOLDERS_DATA = 'GET_FOLDERS_DATA';
const SELECT_FOLDER = 'SELECT_FOLDER';
const SELECT_FILE = 'SELECT_FILE';

const addRemoveFolderOption = data => {
    return {
        type: ADD_REMOVE_FOLDER_OPTION,
        data
    };
}

const updateCategorySelected = data => {
    return {
        type: UPDATE_CATEGORY_SELECTED,
        data
    };
}

const saveFoldersPath = data => {
    return {
        type: SAVE_FOLDERS_PATH,
        data
    };
}

const addRemoveFileOption = data => {
    return {
        type: ADD_REMOVE_FILE_OPTION,
        data
    }
}


const saveFileName = data => {
    return {
        type: SAVE_FILE_NAME,
        data
    }
}

const getFoldersData = () => {
    return {
        type: GET_FOLDERS_DATA
    };
}

const selectFolder = data => {
    return {
        type: SELECT_FOLDER,
        data
    }
}

const selectFile = data => {
    return {
        type: SELECT_FILE,
        data
    }
}


export default {
    types: {
        ADD_REMOVE_FOLDER_OPTION,
        UPDATE_CATEGORY_SELECTED,
        SAVE_FOLDERS_PATH,
        ADD_REMOVE_FILE_OPTION,
        SAVE_FILE_NAME,
        GET_FOLDERS_DATA,
        SELECT_FOLDER,
        SELECT_FILE
    },
    
    actions: {
        addRemoveFolderOption,
        updateCategorySelected,
        saveFoldersPath,
        addRemoveFileOption,
        saveFileName,
        getFoldersData,
        selectFolder,
        selectFile
    }
}